import React from 'react';
import HeroBanner from '../components/HeroBanner/HeroBanner';
import SEO from '../components/SEO/SEO';
import GoogleMapLocation from '../components/GoogleMapLocation/GoogleMapLocation';
import DocHQAddress from '../components/DocHQAddress/DocHQAddress';
import '../assets/styles/contact-page.scss';

const ContactUsPage = () => (
	<>
		<SEO
			title='Contact Us'
			description="Have some questions for us? Send them over and we'll get back to you as swiftly as possible."
		/>
		<HeroBanner
			title='Contact Us'
			tagline='We would love to hear from you. Fill in the details below and we will be in touch to answer any questions or provide further information.'
			imageAlt='Person sending message on computer whilst smiling.'
			imageSrc='contact-us.png'
		/>
		<div className='row' style={{ padding: '0 40px' }}>
			<p style={{ fontWeight: 'bold' }}>
				Contact Us:<br/>
				Email:<a href='mailto:support@dochq.co.uk'> support@dochq.co.uk</a><br/>
				Phone: 03300 880645
			</p>
		</div>
		<div className='row'>
			<div className='col-sm-12 col-md-6'>
				<div className='item'>
					<GoogleMapLocation />
				</div>
			</div>
			<div className='col-sm-12 col-md-6'>
				<div className='item'>
					<DocHQAddress />
				</div>
			</div>
		</div>
	</>
);

export default ContactUsPage;
